import templateStr from 'text!./account-summary.html';

export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            'tableTitle': '@',
            'loading': '=',
            'pageListData': '=?',
            'getLoadByOffset': '=',
            'pageSize': '@'
        }
    };
};
